import { useState } from "react";
import { C, S, G } from "../../utils/theme";
import { saveUser } from "../../utils/data";

function AuthInput({ label, ...props }) {
  return (
    <div style={S.formGroup}>
      <label style={S.label}>{label}</label>
      <input style={S.input} {...props} onFocus={e=>e.target.style.borderColor="#3B82F6"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.1)"} />
    </div>
  );
}

export function Home({ setRoute }) {
  return (
    <div style={{ minHeight:"100vh", background:G.hero, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20, fontFamily:"'Inter',sans-serif", position:"relative", overflow:"hidden" }}>
      {/* Animated background circles */}
      {[...Array(5)].map((_,i)=>(
        <div key={i} style={{ position:"fixed", borderRadius:"50%", background:`rgba(37,99,235,${0.03+i*0.01})`, width:200+i*150, height:200+i*150, top:`${10+i*15}%`, left:`${-10+i*20}%`, pointerEvents:"none", animation:`float ${4+i}s ease-in-out infinite`, animationDelay:`${i*0.5}s` }} />
      ))}

      <div style={{ textAlign:"center", marginBottom:60, position:"relative" }}>
        <img src="/logo.svg" alt="MLK University" style={{ width:88, height:88, margin:"0 auto 20px", display:"block", filter:"drop-shadow(0 8px 20px rgba(201,168,76,0.4))" }} />
        <h1 style={{ color:C.white, fontSize:42, fontWeight:900, margin:0, letterSpacing:-1.5 }}>Martin Luther King University</h1>
        <p style={{ color:"rgba(255,255,255,0.5)", fontSize:16, marginTop:10 }}>Online University Learning Management System</p>
      </div>

      <div style={{ display:"flex", gap:24, flexWrap:"wrap", justifyContent:"center", maxWidth:800, position:"relative" }}>
        {[
          { route:"admin-login", icon:"👨‍💼", title:"Admin Portal", desc:"Manage degrees, students, courses & fees", color:"#2563EB", grd:G.blue, shadow:"rgba(37,99,235,0.4)" },
          { route:"student-login", icon:"👨‍🎓", title:"Student Portal", desc:"Access courses, exams, grades & AI help", color:"#8B5CF6", grd:G.purple, shadow:"rgba(139,92,246,0.4)" },
        ].map(p=>(
          <div key={p.route} onClick={()=>setRoute(p.route)}
            style={{ background:"rgba(255,255,255,0.05)", backdropFilter:"blur(20px)", border:`1px solid rgba(255,255,255,0.1)`, borderRadius:24, padding:"36px 32px", textAlign:"center", cursor:"pointer", width:300, transition:"all 0.3s ease" }}
            onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-8px)";e.currentTarget.style.boxShadow=`0 24px 60px ${p.shadow}`;e.currentTarget.style.borderColor=p.color;}}
            onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";e.currentTarget.style.borderColor="rgba(255,255,255,0.1)";}}>
            <div style={{ width:80, height:80, background:p.grd, borderRadius:20, display:"flex", alignItems:"center", justifyContent:"center", fontSize:38, margin:"0 auto 20px", boxShadow:`0 10px 30px ${p.shadow}` }}>{p.icon}</div>
            <h2 style={{ color:C.white, fontSize:20, fontWeight:800, margin:"0 0 10px" }}>{p.title}</h2>
            <p style={{ color:"rgba(255,255,255,0.5)", fontSize:13, margin:"0 0 24px", lineHeight:1.6 }}>{p.desc}</p>
            <div style={{ background:p.grd, color:C.white, padding:"11px 26px", borderRadius:12, fontSize:14, fontWeight:700, display:"inline-block", boxShadow:`0 6px 20px ${p.shadow}` }}>Login →</div>
          </div>
        ))}
      </div>

      <div style={{ display:"flex", gap:14, marginTop:52, flexWrap:"wrap", justifyContent:"center", position:"relative" }}>
        {["🎓 BS / MS / AD / PhD","📚 General→Core→Specialist","🤖 AI-Powered Q&A","💰 Fees Tracking","🎮 Student Games","📋 MCQ Exams"].map((f,i)=>(
          <span key={i} style={{ padding:"7px 16px", background:"rgba(255,255,255,0.06)", borderRadius:30, color:"rgba(255,255,255,0.6)", fontSize:12, border:"1px solid rgba(255,255,255,0.08)" }}>{f}</span>
        ))}
      </div>
      <style>{`@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}} @keyframes glow{0%,100%{box-shadow:0 20px 50px rgba(37,99,235,0.4)}50%{box-shadow:0 20px 70px rgba(37,99,235,0.7)}}`}</style>
    </div>
  );
}

function LoginPage({ role, onLogin, setRoute }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const isAdmin = role === "admin";
  const color = isAdmin ? "#2563EB" : "#8B5CF6";
  const grd = isAdmin ? G.blue : G.purple;

 const login = async () => {
  setErr("");
  if (!email || !pass) { setErr("Please fill all fields."); return; }
  setLoading(true);
  try {
    const { authAPI } = await import("../../utils/api");
    const res = await authAPI.login(email, pass, role);
    onLogin(res.user, res.token);
  } catch (err) {
    setErr(err.message || "Invalid credentials");
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={{ ...S.authWrap, background: isAdmin ? `linear-gradient(135deg,#0F172A,#1E3A8A,#1E40AF)` : `linear-gradient(135deg,#0F172A,#2E1065,#4C1D95)` }}>
      <div style={{ width:"100%", maxWidth:460 }}>
        <button onClick={()=>setRoute("home")} style={{ ...S.btn("ghost","sm"), marginBottom:20, color:"rgba(255,255,255,0.5)", fontSize:13 }}>← Back to Home</button>
        <div style={{ ...S.authCard, borderTop:`3px solid ${color}` }}>
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <div style={{ width:72, height:72, background:grd, borderRadius:20, display:"flex", alignItems:"center", justifyContent:"center", fontSize:36, margin:"0 auto 16px", boxShadow:`0 12px 35px ${color}55` }}>
             <img src="/logo.svg" alt="MLK University" style={{ width:"100%", height:"100%", objectFit:"contain", padding:8 }} />
            </div>
            <h1 style={{ fontSize:24, fontWeight:800, color:C.white, margin:0 }}>{isAdmin?"Admin Portal":"Student Portal"}</h1>
            <p style={{ fontSize:13, color:"#475569", marginTop:6 }}>Martin Luther King University</p>
          </div>

          {err && <div style={{ background:"rgba(244,63,94,0.12)", color:"#F43F5E", padding:"11px 15px", borderRadius:10, fontSize:13, marginBottom:18, border:"1px solid rgba(244,63,94,0.3)" }}>⚠️ {err}</div>}

          <div style={S.formGroup}>
            <label style={S.label}>{isAdmin?"Admin Email":"Student Email"}</label>
            <input style={S.input} type="email" placeholder={isAdmin?"Admin Email":"student@uni.edu"} value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&login()} onFocus={e=>e.target.style.borderColor=color} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.1)"} />
          </div>
          <div style={S.formGroup}>
            <label style={S.label}>Password</label>
            <div style={{ position:"relative" }}>
              <input style={{ ...S.input, paddingRight:44 }} type={showPass?"text":"password"} placeholder="Enter password" value={pass} onChange={e=>setPass(e.target.value)} onKeyDown={e=>e.key==="Enter"&&login()} onFocus={e=>e.target.style.borderColor=color} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.1)"} />
              <button type="button" onClick={()=>setShowPass(v=>!v)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#475569" }}>{showPass?"🙈":"👁️"}</button>
            </div>
          </div>

          <button onClick={login} disabled={loading} style={{ ...S.btn("primary","lg"), width:"100%", justifyContent:"center", background:grd, boxShadow:`0 8px 25px ${color}44`, opacity:loading?0.7:1 }}>
            {loading ? "Signing in..." : `Sign In →`}
          </button>

          <div style={{ textAlign:"center", marginTop:18, fontSize:13, color:"#475569" }}>
            {isAdmin ? <>Student? <button onClick={() => { window.history.pushState({}, "", "/student-login"); setRoute("student-login"); }} style={{ ...S.btn("ghost","sm"), color:"#8B5CF6", padding:0, fontSize:13 }}>Student Login →</button></>
              : <>Admin? <button onClick={() => { window.history.pushState({}, "", "/admin-login"); setRoute("admin-login"); }} style={{ ...S.btn("ghost","sm"), color:"#2563EB", padding:0, fontSize:13 }}>Admin Login →</button></>}
          </div>
        </div>
      </div>
    </div>
  );
}

export function AdminLogin({ onLogin, setRoute }) { return <LoginPage role="admin" onLogin={onLogin} setRoute={setRoute} />; }
export function StudentLogin({ onLogin, setRoute }) { return <LoginPage role="student" onLogin={onLogin} setRoute={setRoute} />; }
